import { render } from "./CountdownComponent.vue?vue&type=template&id=bd2b0e74&scoped=true"
import script from "./CountdownComponent.vue?vue&type=script&lang=js"
export * from "./CountdownComponent.vue?vue&type=script&lang=js"

import "./CountdownComponent.vue?vue&type=style&index=0&id=bd2b0e74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd2b0e74"]])

export default __exports__